const Vue = require('vue');
const TTSPlayerSimple = require('components/text-to-speech-player-simple.vue').default;
const _ = require('underscore');

module.exports = {
	props: {
		showAudio: {
			default: true
		}
	},
	data() {
		return {
			captionTTSPlayers: []
		};
	},
	methods: {
		async generateCaptionTTSPlayers() {
			if (!this.showAudio) {
				return;
			}

			await Vue.nextTick();

			const eventDataRoot = this.captionTTSEventData;
			const players = [];

			this.$el.querySelectorAll('.image-caption').forEach((captionElement, captionId) => {
				const text = captionElement.textContent;

				if (text.trim()) {
					const lastChildWithText = Array.from(captionElement.children).reduce((current, child) => {
						if (child.textContent.trim()) {
							return child;
						}

						return current;
					}, null);

					const el = document.createElement('span');
					lastChildWithText.appendChild(el);
					const eventData = Object.assign({}, eventDataRoot, {
						tag: `image-caption-${captionId + 1}`
					});

					const selectedArticle = this.selectedArticle;
					const language = this.language || (selectedArticle && selectedArticle.language);

					const player = new (Vue.extend(TTSPlayerSimple))({
						el,
						propsData: {
							text,
							eventData,
							language
						}
					});
					players.push(player);
				}
			});

			this.captionTTSPlayers = players;
		},
		destroyCaptionTTSPlayers() {
			this.captionTTSPlayers.forEach(player => {
				player.$el.remove();
				player.$destroy();
			});
			this.captionTTSPlayers = [];
		},
		updateCaptionTTSPlayers: _.debounce(function () {
			const players = this.captionTTSPlayers;
			const playerUnrendered = players.some(player => !player.$el.isConnected);
			const expectedPlayerCount = Array.from(this.$el.querySelectorAll('.image-caption')).filter(player => !!player.textContent.trim()).length;

			if (playerUnrendered || players.length !== expectedPlayerCount) {
				this.destroyCaptionTTSPlayers();
				this.generateCaptionTTSPlayers();
			}
		}, 10)
	},
	computed: {
		captionTTSEventData() {
			const selectedArticle = this.selectedArticle;
			const article = this.article;

			if (!selectedArticle) {
				return {};
			}

			const parentPid = article && selectedArticle !== article ? article.uuid : undefined;
			const pid = selectedArticle.uuid;

			return {
				parentPid,
				pid
			};
		}
	},
	mounted() {
		this.generateCaptionTTSPlayers();
	},
	updated() {
		this.updateCaptionTTSPlayers();
	},
	beforeDestroy() {
		this.destroyCaptionTTSPlayers();
	}
};
